var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dots-item",class:{ red: _vm.red },on:{"click":_vm.onItemClick}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }